import(/* webpackMode: "eager" */ "/build/bcb5887a-4c8f-4e2d-86fe-16ead6d49f0d/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/bcb5887a-4c8f-4e2d-86fe-16ead6d49f0d/node_modules/react-wavify/lib/index.module.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/bcb5887a-4c8f-4e2d-86fe-16ead6d49f0d/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/bcb5887a-4c8f-4e2d-86fe-16ead6d49f0d/src/design-system/buttons/ButtonLink.tsx");
;
import(/* webpackMode: "eager" */ "/build/bcb5887a-4c8f-4e2d-86fe-16ead6d49f0d/src/design-system/layout/Main.tsx");
